import { cn, pluralize } from "@theprelude/core";
import { AlertIcon, ExceptionIcon, ResourceTypeIcon } from "@theprelude/ds";
import { ResourceType } from "@/queries/control-monitor";

export const PolicyStatus = ({
  resourceType,
  resourceCount,
  misconfigurationCount,
  exceptionCount,
}: {
  resourceType: ResourceType;
  resourceCount: number;
  misconfigurationCount: number;
  exceptionCount: number;
}) => (
  <div className="mr-2 flex items-center gap-2 whitespace-nowrap text-sm">
    <div className="flex items-center gap-1">
      <ResourceTypeIcon
        resourceType={resourceType}
        className="text-secondary-foreground"
      />
      <span>{resourceCount.toLocaleString()}</span>
    </div>
    <div
      className={cn(
        "flex items-center gap-1",
        misconfigurationCount > 0 ? "text-status-red" : "text-status-green",
      )}
    >
      <AlertIcon />
      <span>
        {misconfigurationCount.toLocaleString()}{" "}
        {pluralize(misconfigurationCount, "issue")}
      </span>
    </div>
    {exceptionCount > 0 && (
      <div className="flex items-center gap-1">
        <ExceptionIcon />
        <span className="inline-flex items-center justify-center rounded-full bg-tertiary-background px-2 py-0 text-[0.625rem] text-white font-normal">
          {exceptionCount.toLocaleString()}
        </span>
      </div>
    )}
  </div>
);
